import bus from '~/bus'
import { getEventFile } from '~/helpers/eventHelper'
export default {
  name: 'completed',
  do: function (payload) {
    console.log('DEBUG completed: ', this, payload)
    if ((this.fileChildren && this.fileChildren.includes(payload.file_id)) || this.file === payload.file_id) {
      getEventFile(payload.deprecated_file_id, 'completed').then((response) => {
        bus.$emit('updateFile', response)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/completed.js